import PropTypes from 'prop-types';
import { Form } from "react-bootstrap";

/**
 * A labeled checkbox component
 * 
 * @param {object} props
 * @param {string} props.id - Checkbox ID
 * @param {string} props.label - Checkbox label
 * @param {boolean} props.checked - Checkbox checked state
 * @param {Function} props.onChange - Function that runs when checkbox is toggled
 * @param {boolean} props.disabled - True if checkbox should be disabled, false otherwise
 */
const LabeledCheckbox = ({ id, label, checked, onChange, disabled, optionalMessage, colorOptional }) => {
    return (
        <div className='left-align'>
        <div style={{ textAlign: 'left', margin: 0}} dangerouslySetInnerHTML={{ __html: optionalMessage }}/>
        <Form.Group className="d-flex align-items-center justify-content-between">
            <Form.Label style={{color: colorOptional || "black"}} className="mb-0 me-2 fs-5" htmlFor={id}>{label}</Form.Label>
            <Form.Check
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={disabled}
                className="custom-checkbox"
                style={{ marginTop: '3px' }}
            />
        </Form.Group>
        </div>
        
    );
};

LabeledCheckbox.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    optionalMessage: PropTypes.string,
};

export default LabeledCheckbox;
